<template>
  <div class="info-card">
    <div class="info-card-inner">
      <div class="info-card-head">
        <div v-if="props.staticIcon" class="card-icon flex items-center">
          <img :src="staticIcon" :alt="getWidgetTextTranslation(props.title)" />
        </div>
        <div
          v-else-if="icon"
          :class="{ 'card-icon': !props.noPadding, 'card-image': props.noPadding }"
          class="flex items-center">
          <img :src="icon" :alt="getWidgetTextTranslation(props.title)" />
        </div>
        <div v-else-if="props.image" class="card-image" :style="{ backgroundImage: `url('${image}')` }" />
      </div>
      <div class="info-card-body">
        <div class="flex flex-col gap-4 h-full">
          <h3 class="h5" v-text="getWidgetTextTranslation(props.title)" />
          <div
            class="flex text-text2 dark:text-dmText2 text-sm flex-1 leading-tight"
            v-text="getWidgetTextTranslation(props.description)" />
          <LinkElement v-if="props.slug" :to="props.slug" :text="t('common.learn-more')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LinkElement from '~/components/LinkElement.vue'

import type { TranslatableString } from '~/types/widgets/widgetTypes'
import getWidgetTextTranslation from '~/utils/getWidgetTextTranslation'
import getWidgetTranslatedMediaUrl from '~/utils/getWidgetTranslatedMediaUrl'

const props = defineProps<{
  title: TranslatableString
  description: TranslatableString
  slug?: string
  image?: TranslatableString
  icon?: TranslatableString
  staticIcon?: string
  noPadding?: boolean
}>()
const { t } = useLang()

const icon = props.icon && getWidgetTranslatedMediaUrl(props.icon)
const image = props.image && getWidgetTranslatedMediaUrl(props.image)
</script>

<style lang="postcss" scoped>
.info-card {
  @apply flex h-full rounded-sm overflow-hidden;

  .info-card-inner {
    @apply flex flex-col h-full shadow-none;

    .info-card-body {
      @apply p-4 md:p-5;

      a {
        @apply w-fit;
      }
    }
  }
}

.dark .info-card {
  .info-card-inner {
    .card-icon img {
      @apply invert;
    }
  }
}

.info-card {
  .card-icon {
    padding: 1.25rem 1.25rem 0 1.25rem;
  }

  .card-image {
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  .card-image {
    height: 14rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
